/**
 * usePaymentTerms Hook
 * ahooks data fetching hook for payment terms (base templates)
 */

import { useRequest } from 'ahooks';
import type { Options } from 'ahooks/lib/useRequest/src/types';
import { paymentTermApi } from '@/services/api';
import type { PaymentTermsResponse } from '@/types/api/paymentTerm';

/**
 * Hook to fetch all payment terms (base templates)
 * These are the standard payment term templates like NET, DISCOUNT, EOM, etc.
 * @param typeId - Payment term type ID (1=Vendor, 2=Customer)
 */
export function usePaymentTerms(typeId: 1 | 2, config?: Options<PaymentTermsResponse, []>) {
  const { data, error, loading, refresh } = useRequest(
    () => paymentTermApi.list(typeId),
    {
      refreshDeps: [typeId],
      cacheKey: `/api/payment-terms?typeId=${typeId}`,
      staleTime: 5 * 60 * 1000, // 5 minutes - payment terms don't change often
      ...config,
    }
  );

  return {
    paymentTerms: data?.paymentTerms ?? [],
    error,
    isLoading: loading,
    mutate: refresh,
    refresh,
  };
}
